(function () {
  function init(root) {
    if (!root || root.dataset.nbSaReady) return;
    root.dataset.nbSaReady = '1';

    // Mueve la barra al body para escapar del grid y de contextos de apilamiento
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var btn   = root.querySelector('[data-nb-sa-add]');
    var price = root.querySelector('[data-nb-sa-price]');
    var sel   = root.querySelector('[data-nb-sa-sel]');
    if (!btn) return;

    function paint(opt) {
      if (!price || !opt) return;
      var cmp = opt.dataset.compare;
      price.innerHTML = (cmp ? '<s>' + cmp + '</s>' : '') + (opt.dataset.price || '');
    }

    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        btn.dataset.vid = sel.value;
        btn.disabled = opt.disabled;
        paint(opt);
      });
    }

    // Refleja la talla elegida arriba en la página
    document.addEventListener('change', function (e) {
      if (!sel) return;
      if (!e.target.closest('.product-form__input, variant-radios, variant-selects')) return;

      setTimeout(function () {
        var input = document.querySelector('.product-variant-id, [name="id"]');
        if (!input || !input.value) return;
        sel.value = input.value;
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        btn.dataset.vid = sel.value;
        btn.disabled = opt.disabled;
        paint(opt);
      }, 350);
    });
    // --- Mostrar / ocultar según el botón original ---
    var target =
      document.querySelector('.product-form__submit') ||
      document.querySelector('[name="add"]');

    // El widget usa position:relative — hay que mover el contenedor fijo
    function findWaHost() {
      var link = document.getElementById('whatsapp-link');
      if (!link) return null;

      var node = link;
      while (node && node !== document.body) {
        var pos = window.getComputedStyle(node).position;
        if (pos === 'fixed' || pos === 'sticky') return node;
        node = node.parentElement;
      }
      return link;
    }

    var waHost = null;

    function moveWa(on) {
      if (!waHost) waHost = findWaHost();
      if (!waHost) return;

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      waHost.style.transition = 'transform 340ms cubic-bezier(.16,1,.3,1)';
      waHost.style.transform = on && isMobile ? 'translateY(-96px)' : '';
    }

    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var on = !e.isIntersecting;
            root.classList.toggle('is-on', on);
            moveWa(on);
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0 }
      ).observe(target);
    } else {
      root.classList.add('is-on');
      moveWa(true);
    }


    // --- Agregar al carrito ---
    btn.addEventListener('click', function () {
      var id = btn.dataset.vid;
      if (!id || btn.disabled) return;

      var original = btn.dataset.label || btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';

      var body = { items: [{ id: Number(id), quantity: 1 }] };

      // Pide las secciones del drawer para refrescarlo
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Error');

          btn.textContent = btn.dataset.ok || 'Agregado';
          btn.classList.add('is-ok');

          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            var wasEmpty = drawer.classList.contains('is-empty');
            drawer.classList.remove('is-empty');

            try {
              drawer.renderContents(data);
            } catch (err) {
              if (wasEmpty) {
                window.location.reload();
                return;
              }
              throw err;
            }
          } else {
            window.location.reload();
          }

          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-ok');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  function replaceSections(sections) {
    var map = {
      'cart-drawer':      { hostId: 'CartDrawer',       selector: '.drawer__inner' },
      'cart-icon-bubble': { hostId: 'cart-icon-bubble', selector: '.shopify-section' }
    };

    Object.keys(sections).forEach(function (key) {
      var cfg = map[key];
      if (!cfg) return;

      var host = document.getElementById(cfg.hostId);
      if (!host) return;

      var tmp = document.createElement('div');
      tmp.innerHTML = sections[key];

      var fresh = tmp.querySelector(cfg.selector);
      if (!fresh) return;

      var dest = host.querySelector(cfg.selector) || host;
      dest.innerHTML = fresh.innerHTML;
    });
  }

  function boot() {
    document.querySelectorAll('.nb-sa').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();